import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import MediaConsentComp from './MediaConsentComp'
import './dash.css'

function MediaConsent() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <MediaConsentComp />
      </div>
    </div>
  )
}

export default MediaConsent
